import {
	toParams,
	fromParamMap,
} from 'src/admin-app/utilities/list-filtering/shared';
import { UserListArgs } from 'src/shared/api';
import {
	toTextFilterParams,
	toTextFilterListArgs,
} from 'src/admin-app/utilities/list-filtering/mappers';

export const convertToAdminUserListParams = toParams<UserListArgs>(
	toTextFilterParams
);

export const convertToAdminUserListArgs = fromParamMap<UserListArgs>(
	toTextFilterListArgs
);
